"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUMOCEPUserSelectors = void 0;
const reselect_1 = require("reselect");
const selectUserState = (state) => state.SUMOCEP_user;
const selectIsAuthorized = (0, reselect_1.createSelector)(selectUserState, (user) => user.isAuthorized);
const selectIsLicenseValid = (0, reselect_1.createSelector)(selectUserState, (user) => user.isLicenseValid);
const selectUser = (0, reselect_1.createSelector)(selectUserState, (user) => user.user);
const selectRole = (0, reselect_1.createSelector)(selectUserState, (user) => user.role);
const selectIsFetching = (0, reselect_1.createSelector)(selectUserState, (user) => user.isFetching);
const selectIsFetchingUserData = (0, reselect_1.createSelector)(selectUserState, (user) => user.isFetchingUserData);
const selectIsSalesforceAuthorizationCodeFetching = (0, reselect_1.createSelector)(selectUserState, (user) => user.isSalesforceAuthorizationCodeFetching);
const selectIsSalesforceLoginFetching = (0, reselect_1.createSelector)(selectUserState, (user) => user.isSalesforceLoginFetching);
exports.SUMOCEPUserSelectors = {
    selectUserState,
    selectIsAuthorized,
    selectIsLicenseValid,
    selectUser,
    selectRole,
    selectIsFetching,
    selectIsFetchingUserData,
    selectIsSalesforceAuthorizationCodeFetching,
    selectIsSalesforceLoginFetching,
};
